import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FFPaper from '../../../components/shared/FFPaper';
import Title from '../../../components/shared/Title';
import EventListTopTools from '../../../components/dashboard/events/EventListTopTools';
import EventListColumnHeader from '../../../components/dashboard/events/EventListColumnHeader';
import EventListTable, { EventListData } from '../../../components/dashboard/events/EventListTable';


const eventListData: EventListData[] = [
    {
        photo: ["images/people/picthumb1.png","images/people/picthumb1.png"],
        mathConfidence: 0.90,
        cameraStation: "Manual Camera",
        eventLocation: "Store #467",
        tags: "Committed Thef",
        eventDateTime: new Date(),
    },
    {
        photo: ["images/people/picthumb1.png","images/people/picthumb1.png"],
        mathConfidence: 0.80,
        cameraStation: "Manual Camera",
        eventLocation: "Store #434",
        tags: "Committed Thef",
        eventDateTime: new Date(),
    },
    {
        photo: ["images/people/picthumb1.png","images/people/picthumb1.png"],
        mathConfidence: 0.90,
        cameraStation: "Automatic Camera",
        eventLocation: "Store #437",
        tags: "Committed Thef",
        eventDateTime: new Date(),
    },
    {
        photo: ["images/people/picthumb1.png","images/people/picthumb1.png"],
        mathConfidence: 0.70,
        cameraStation: "Manual Camera",
        eventLocation: "Store #477",
        tags: "Committed Thef",
        eventDateTime: new Date(),
    }
]

export default function EventsList() {

    return (
        <Grid item={true} xs={12} sx={{ height: '100%' }}>
            
            <EventListTopTools />

            <FFPaper
                elevation={3}
                sx={{
                    height: '100%',
                    paddingTop: '25px',
                    mt: 3,
                    pl: 0
                }}
            >
                <Box sx={{ pl: 4 }}>
                    <Title big={true} notooltip={true}>Events</Title>
                </Box>

                <Grid item={true} xs={12} sx={{ height: '100%', pt: 2 }}>
                    <EventListColumnHeader />

                    <EventListTable data={eventListData} />

                </Grid>

            </FFPaper>
        </Grid >
    )
}